import { alphabetGenerator } from 'utillities/alphabet-utilities';
import { INPUTS_TABLE_ALIASES } from '../../../../../common/constants/calibration';
import { Cells } from '../../../../../common/types/scalarSpreadsheet';
import { getObjectValue, gridShortDate } from '../../../../../utillities';
import {
  VALUATION_SUMMARY_SPREADSHEET_LESS_CASH,
  VALUATION_SUMMARY_SPREADSHEET_PLUS_DEBT,
} from '../../../../ValuationsAllocation/common/constants/valuationSummary/sheetAliases';
import { CustomParserParamCalibration } from '../../guidelinePublicCompanies/PerformanceMetrics/config/customParser/types';
import { getFinalValueByAlias, getPlusDebtAndLessCashInputsTable, validateHiddenRows } from '../utils';

const parser = async (params: CustomParserParamCalibration) => {
  const { columns, rowConfig, tableData } = params;
  let cells = {} as Cells;
  const { calibration, isDisabled } = tableData;
  const calibrationData = calibration;
  const alphabet = alphabetGenerator([], columns.length);
  const columnsLength = columns.length;

  columns.forEach((column, columnIndex: number) => {
    const columnLegend = alphabet[columnIndex];

    rowConfig.forEach((row, rowIdx: number) => {
      const rowNumber = rowIdx + 1;
      const key = columnLegend + rowNumber;
      const colNumber = columnIndex + 1;
      const isLastColumn = colNumber === columnsLength;
      const { alias } = getObjectValue(row);
      let { gridType, expr, rowNumberPair, exprPair, readOnly } = row;

      let value = getFinalValueByAlias(column[alias]?.value ?? '', gridType, calibrationData, alias);
      const { format } = row;

      let { style } = column;
      style = validateHiddenRows(rowNumber, style);

      const enterPriseValueExpr = `=equity_value_inputs + ${VALUATION_SUMMARY_SPREADSHEET_PLUS_DEBT} - ${VALUATION_SUMMARY_SPREADSHEET_LESS_CASH} `;
      const equityValueExpr = `=enterprise_value_inputs- ${VALUATION_SUMMARY_SPREADSHEET_PLUS_DEBT} + ${VALUATION_SUMMARY_SPREADSHEET_LESS_CASH}`;
      const isEnterpriseValueCalculated = false;
      switch (alias) {
        case INPUTS_TABLE_ALIASES.CALIBRATION_DATE:
          value = gridShortDate(value);
          break;
        case VALUATION_SUMMARY_SPREADSHEET_LESS_CASH:
          ({ gridType, readOnly, value } = getPlusDebtAndLessCashInputsTable(
            isDisabled,
            isLastColumn,
            gridType,
            calibrationData,
            readOnly,
            value,
            true
          ));
          break;
        case VALUATION_SUMMARY_SPREADSHEET_PLUS_DEBT:
          ({ gridType, readOnly, value } = getPlusDebtAndLessCashInputsTable(
            isDisabled,
            isLastColumn,
            gridType,
            calibrationData,
            readOnly,
            value,
            false
          ));
          break;
        case INPUTS_TABLE_ALIASES.ENTERPRISE_VALUE_INPUTS:
          expr = isEnterpriseValueCalculated ? enterPriseValueExpr : null;
          exprPair = enterPriseValueExpr;
          rowNumberPair = 7;
          break;
        case INPUTS_TABLE_ALIASES.EQUITY_VALUE_INPUTS:
          expr = !isEnterpriseValueCalculated ? equityValueExpr : null;
          exprPair = equityValueExpr;
          rowNumberPair = 4;
          break;
        case INPUTS_TABLE_ALIASES.LTM_REVENUE_INPUTS:
        case INPUTS_TABLE_ALIASES.NTM_REVENUE_INPUTS:
        case INPUTS_TABLE_ALIASES.LTM_EBITDA_INPUTS:
        case INPUTS_TABLE_ALIASES.NTM_EBITDA_INPUTS:
          if (Number(calibrationData.financials_version) === 0 && !isDisabled) {
            readOnly = false;
          }
          break;
        case INPUTS_TABLE_ALIASES.FINANCIALS_VERSION:
          if (value === '') {
            value = 0;
          }
          break;
        default:
          break;
      }

      const cell = {
        key,
        alias: row.alias || '',
        columnId: column.id,
        columnLegend,
        columnOrder: column.order,
        customFormat: column.customFormat || null,
        ignoreAutoScroll: row.ignoreAutoScroll,
        isNotNavigable: row.isNotNavigable,
        isParent: column.isParent,
        parentColumn: column.parentColumn,
        rowNumber,
        value,
        isGpcRow: false,
        readOnly,
        style,
        format,
        gridType,
        customKey: alias,
        expr,
        rowNumberPair,
        exprPair,
        dbType: 'string',
      };

      cells = {
        ...cells,
        [key]: cell,
      };
    });
  });

  return cells;
};

export default parser;
